import React from 'react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { toLower } from 'lodash';
import startCase from 'lodash/startCase';
var statusBgClassNames = {
    OPEN: 'lfc-bg-success-300',
    LIKELY_TO_OPEN: 'lfc-bg-warning-100'
};
var statusTextClassNames = {
    OPEN: 'lfc-text-[#3C5B31]',
    LIKELY_TO_OPEN: 'lfc-text-[#7F572A]'
};
var IntakeChip = function (_a) {
    var _b;
    var groupKey = _a.groupKey, value = _a.value, showInfo = _a.showInfo;
    return (React.createElement("div", { key: groupKey, className: " lfc-mx-2 lfc-flex lfc-items-center ".concat((_b = statusBgClassNames[groupKey]) !== null && _b !== void 0 ? _b : 'lfc-bg-gray-100', " lfc-p-1.5 lfc-rounded lfc-text=[#1C1C1C]") },
        React.createElement(Typography, { variant: "caption1", className: statusTextClassNames[groupKey] }, startCase(toLower(groupKey))), value === null || value === void 0 ? void 0 :
        value.map(function (item, idx) { return (React.createElement("div", { key: item, className: "lfc-mx-2" },
            React.createElement(Typography, { variant: "subtitle2" },
                startCase(item === null || item === void 0 ? void 0 : item.month.toLowerCase()),
                " ", item === null || item === void 0 ? void 0 :
                item.year,
                idx + 1 !== (value === null || value === void 0 ? void 0 : value.length) && React.createElement(React.Fragment, null, ","),
                showInfo && (React.createElement(Tooltip, { title: "".concat(startCase(groupKey.toLowerCase()), " Date: ").concat(new Date(item.open_date).toDateString()) },
                    React.createElement(InfoOutlined, { fontSize: "small", color: "primary", className: "lfc-ml-1 lfc-h-3 lfc-w-3" })))))); })));
};
export default IntakeChip;
//# sourceMappingURL=IntakeChip.js.map